import { Fragment } from 'react';

// Placeholder component for text that should be translated

interface MessageProps {
  text: string,
  values?: Record<string, React.ReactNode>,
}

const re = /{([^}]+)}/g; // "Finds {words} in {brackets}"

export const Message: React.FC<MessageProps> = ({ text, values }) => {
  if (!values) return text as unknown as React.ReactElement;
  const matches = Array.from(text.matchAll(re));
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  matches.forEach((match, i) => {
    if (match.index == null) return;
    parts.push((
      <Fragment key={i}>
        {text.slice(lastIndex, match.index)}
        {values[match[1]]}
      </Fragment>
    ));
    lastIndex = match.index + (match[0] || '').length;
  });
  parts.push(text.slice(lastIndex));

  return parts as unknown as React.ReactElement;
};

export const message = (text: string): string => text;
